import { Alert, Button, Divider, Form } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useCreateUser } from '../../Hooks/useCreateUser';
import Icon, { UserAddOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { GoogleIcon, MicrosoftIcon } from '../../Components/Buttons/GoogleButton';
import PageSmall from '../../Components/Page/PageSmall';
import BookyBox from '../../Components/Layout/BookyBox';
import { BookyInput, InputType } from '../../Components/Forms/BookyInput';
import { BookyPageTitle } from '../../Components/Layout/BookyTitle';
import { TextService } from '../../Services/TextService';
import { getCurrentLanguage } from '../../Helpers/RouteHelper';
import './CreateUser.css';

const CreateUserForm = (props: any) => {
    const navigation = useNavigate();
    const GetText = TextService.GetText;

    return <div className="create-user-container">
        {!props.finishSetupText && !props.hideGoogleOption && (
            <div className="create-user-welcome">
                <UserAddOutlined className="create-user-welcome-icon" />
                <h1 className="create-user-welcome-title">{GetText("CreateUser_WelcomeTitle")}</h1>
                <p className="create-user-welcome-subtitle">{GetText("CreateUser_WelcomeSubtitle")}</p>
            </div>
        )}

        <Form
            data-testid="create-form"
            onFinish={props.onCreateUserSubmit}
            wrapperCol={{
                span: 24,
            }}
            layout="vertical"
            autoComplete="off"
        >
            {props.finishSetupText ? (
                <Alert message={props.finishSetupText} style={{ marginBottom: "24px" }} type="success" showIcon />
            ) : !props.hideGoogleOption ? (
                <div className="create-user-benefits">
                    <h4>{GetText("CreateUser_Benefits")}</h4>
                    <ul>
                        <li>{GetText("CreateUser_Benefit1")}</li>
                        <li>{GetText("CreateUser_Benefit2")}</li>
                        <li>{GetText("CreateUser_Benefit3")}</li>
                    </ul>
                </div>
            ) : null}

            <Form.Item name="refCode" className="hp-field" aria-hidden="true">
                <input tabIndex={-1} autoComplete="off" />
            </Form.Item>

            {props.showCompanyName && <BookyInput label={GetText("CreateUser_CompanyName")} name="companyname" requiredMessage={GetText("CreateUser_CompanyName_Validation")} />}
            <BookyInput label={GetText("CreateUser_FirstName")} name="firstname" requiredMessage={GetText("CreateUser_FirstName_Validation")}></BookyInput>
            <BookyInput label={GetText("CreateUser_LastName")} name="lastname" requiredMessage={GetText("CreateUser_LastName_Validation")}></BookyInput>
            {props.hideEmailInput ? "" : <BookyInput label={GetText("CreateUser_Email")} type={InputType.email} name="email" requiredMessage={GetText("CreateUser_Email_Validation")} />}
            <BookyInput label={GetText("CreateUser_Password")} type={InputType.password} name="password" placeholder="" requiredMessage={GetText("CreateUser_Password_Validation")} />

            <Form.Item style={{ marginTop: "24px" }}>
                <Button
                    data-testid="create-user-button"
                    className="create-user-submit-btn"
                    style={{ width: "100%" }}
                    size="large"
                    type="primary"
                    htmlType="submit"
                >
                    {GetText("CreateUser_Create")}
                </Button>
            </Form.Item>

            {props.errorText && (
                <Alert
                    showIcon={true}
                    type="warning"
                    message={props.errorText}
                    action={
                        <Button
                            onClick={() => navigation("/" + getCurrentLanguage() + "/Login")}
                            size="small"
                            type="primary"
                        >
                            {GetText("CreateUser_Login")}
                        </Button>
                    }
                />
            )}

            {!props.hideGoogleOption && (
                <>
                    <Divider className="create-user-divider">{GetText("Login_DividerOr")}</Divider>

                    <Button
                        size="large"
                        className="create-user-google-btn"
                        style={{ width: "100%", marginBottom: "10px" }}
                        onClick={props.onRedirectToGoogle}
                    >
                        <Icon component={GoogleIcon} />
                        {GetText("CreateUser_SignUpWithGoogle")}
                    </Button>

                    <Button
                        size="large"
                        className="create-user-microsoft-btn"
                        style={{ width: "100%" }}
                        onClick={props.onRedirectToMicrosoft}
                    >
                        <Icon component={MicrosoftIcon} />
                        {GetText("CreateUser_SignUpWithMicrosoft")}
                    </Button>

                    <div className="create-user-login-link">
                        {GetText("CreateUser_AlreadySignedUp")} <a href="/Login">{GetText("CreateUser_Login")}</a>
                    </div>
                </>
            )}
        </Form>
    </div>
}

export default CreateUserForm;